// Generated by scripts/build-ui-icons.mjs.
export { FilePdf as default } from "../ui/glyphs-3";
